import actionTypes from '../constants/action-types';

const reloadSiteMeta = (site, resolve = Function.prototype, reject = Function.prototype) => ({
  type: actionTypes.RELOAD_SITE_META,
  payload: {
    site,
    resolve,
    reject,
  },
});

export default reloadSiteMeta;
